export default "__VITE_PUBLIC_ASSET__eb6fa671__"